import React from 'react';
import { Site } from '../../lib/Site';
import CompanyMenu from './CompanyMenu';
import DesignServicesMenu from './DesignServicesMenu';
import GetDesignMenu from './GetDesignMenu';
import ResourcesMenu from './ResourcesMenu';

interface Props {
    site: Site;
}

export default function SiteFooterNavigation({ site }: Props) {
    return (
        <div className="site-footer__navigation">
            <div className="site-footer__navigation__inner">
                <div className="site-footer__navigation__group">
                    <h5 className="heading heading--h6 heading--grey800">{__('Company')}</h5>
                    <CompanyMenu />
                </div>
                <div className="site-footer__navigation__group">
                    <h5 className="heading heading--h6 heading--grey800">
                        {__('Design services')}
                    </h5>
                    <DesignServicesMenu site={site} />
                </div>
                <div className="site-footer__navigation__group">
                    <h5 className="heading heading--h6 heading--grey800">{__('Get a design')}</h5>
                    <GetDesignMenu site={site} />
                </div>
                <div className="site-footer__navigation__group">
                    <h5 className="heading heading--h6 heading--grey800">{__('Resources')}</h5>
                    <ResourcesMenu site={site} />
                </div>
            </div>
        </div>
    );
}
